import { z } from "zod/v4";

import { JsonSchema } from "../../../../../utils";

export const PluginCurrencySchema_2023_08_20 = z.object({
  options: JsonSchema,
  symbol: z.string().default("$"),
  suffix: z.string().default(""),
  removeTrailingZeros: z.boolean().default(false),
});
export type PluginCurrencyType_2023_08_20 = z.infer<
  typeof PluginCurrencySchema_2023_08_20
>;
